import React from "react";
import { ShoppingCart } from "lucide-react";
import Stars from "./Stars";
import { useCart, formatPrice } from "../context/CartContext";

export default function ProductCard({ p, className = "" }) {
  const { addItem } = useCart();
  const discount = p.compareAt
    ? Math.round((1 - p.price / p.compareAt) * 100)
    : 0;
  return (
    <div
      className={`group flex flex-col overflow-hidden rounded-2xl border border-navy/10 bg-white shadow-sm transition-all hover:-translate-y-1 hover:shadow-xl ${className}`}
    >
      <div className="relative aspect-square overflow-hidden bg-white p-4">
        {discount > 0 && (
          <span className="absolute left-3 top-3 z-10 rounded-full bg-brand px-2.5 py-1 text-[11px] font-bold text-white">
            -{discount}%
          </span>
        )}
        <img
          src={p.image}
          alt={p.name}
          className="h-full w-full object-contain transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex flex-1 flex-col border-t border-navy/5 p-4">
        <Stars value={p.rating} />
        <h3 className="mt-2 line-clamp-2 min-h-[40px] text-sm font-semibold leading-snug text-navy">
          {p.name}
        </h3>
        <div className="mt-2 flex items-baseline gap-2">
          <span className="font-heading text-lg font-extrabold text-navy">{formatPrice(p.price)}</span>
          {p.compareAt && (
            <span className="text-sm text-navy/40 line-through">{formatPrice(p.compareAt)}</span>
          )}
        </div>
        <button
          onClick={() => addItem(p)}
          className="mt-3 flex items-center justify-center gap-2 rounded-full bg-navy py-2.5 text-xs font-bold uppercase tracking-wide text-white transition-colors hover:bg-brand"
        >
          <ShoppingCart size={15} /> Add to Cart
        </button>
      </div>
    </div>
  );
}
